/**
 * Created by slava on 3/6/19
 */

const CellHintAlgorithm = {
    type: "cellBooster",

    findMove: function () {
        if (!Game.currentGame || !Game.currentGame.field) {
            return;
        }

        const ideas = [
            CellHintAlgorithm.removeBombIdea,
            CellHintAlgorithm.moveToBottomIdea,
            CellHintAlgorithm.collectMarkIdea,
            CellHintAlgorithm.completeGoalIdea
        ];

        const move = HintHelper.findMove(ideas, cleverapps.Boosters.TYPE_CELL);
        if (move) {
            move.type = CellHintAlgorithm.type;
            move.delay = 3000;
            return move;
        }
    },

    removeBombIdea: function (cell) {
        if (cell.constructor.name !== "BombCell") {
            return;
        }

        const untilExplode = cell.untilExplode;

        if (untilExplode <= 3 && untilExplode > 0) {
            return true;
        }
    },

    completeGoalIdea: function (cell) {
        if (!HintHelper.isActiveGoal(cell) || HintHelper.countSameGoals(cell) > 3) {
            return;
        }

        if (cell.constructor.name === "CandleCell") {
            return cell.state === CandleCell.STATE_OFF && HintHelper.countSameGoals(cell) === 1;
        }

        return cell.hurtable && cell.lives === 1;
    },

    collectMarkIdea: function (cell) {
        let markComponent = cell.findComponent(MarkComponent);
        if (!markComponent || !markComponent.mark) {
            return;
        }

        let totalMarks = 0;

        const field = Game.currentGame.field;

        field.iterateCells((cell) => {
            markComponent = cell.findComponent(MarkComponent);
            if (markComponent && markComponent.mark) {
                totalMarks++;
            }
        });

        return totalMarks <= 2;
    },

    moveToBottomIdea: function (cell) {
        const field = Game.currentGame.field;
        const upperCell = cell.y > 0 && field.cells[cell.y - 1][cell.x];
        if (!upperCell || !HintHelper.isBottomRowElement(upperCell)) {
            return;
        }

        let bottomCell = undefined;
        for (let i = cell.y; i < Field.SIZE; i++) {
            if (field.cells[i][cell.x]) {
                if (bottomCell) {
                    return false;
                }

                bottomCell = field.cells[i][cell.x];
            }
        }

        if (!bottomCell || !HintHelper.isRemovable(bottomCell)) {
            return;
        }

        return true;
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(CellHintAlgorithm);
